import { Component, OnInit, TemplateRef } from "@angular/core";
import { InspectionService } from "./../inspection.service";
import { CommonService } from "../../../services/common.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap";
import { UserModalComponentComponent } from "./../user-modal-component/user-modal-component.component";
import { ExcelService } from "./../../../services/excel.service";
import { environment } from "../../../../environments/environment";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-inspection-list-accepted",
  templateUrl: "./inspection-list-accepted.component.html",
  styleUrls: ["./inspection-list-accepted.component.sass"],
})
export class InspectionListAcceptedComponent implements OnInit {
  loader = true;
  items: any;
  listData: any;
  status: any;
  reason: any;
  email;
  email1;
  p = 1;
  nodata = false;
  searchText = "";
  selecttype;
  arr_temp = [];
  arr_temp_all = [];
  modalRef: BsModalRef;
  check: boolean;
  listtype_both: any;
  listtype_Accepted: any;
  listtype_Rejected: any;
  obj: any;
  engineer;
  excel = [];
  query: any = {
    page: 1,
    limit: environment.defaultPageSize,
    userType: 1,
  };
  recordsPerPage: number;
  totalRecords = 0;
  APIEndpoint = "";

  constructor(
    private inspection: InspectionService,
    private commonService: CommonService,
    private modalService: BsModalService,
    private excelService: ExcelService,
    private http: HttpClient
  ) {
    this.recordsPerPage = environment.defaultPageSize;
    this.APIEndpoint = environment.APIEndpoint;

  }
  private searchTerms = new Subject<string>();
  ngOnInit() {
    this.getInspectionListByStatus("Accepted");
    this.status = [
      "Open",
      "Pending",
      "Qualified",
      "Accepted",
      "Rebook",
      "Rural",
      "Rejected",
      "Confirmed",
      // "Deleted",
    ];
    this.reason = ["Wrong service", "Wrong area"];
    this.arr_temp = [];
    //this.status = '';
    this.searchTerms
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((value) => {
        this.query.search = value;
        this.pageChanged({ page: 1 });
        // this.engineerlist();
      });
    this.engineerlist();
  }

  getValue(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.searchTerms.next(inputElement.value);
    // return (event.target as HTMLInputElement).value;
  }
  openModal(template: TemplateRef<any>) {
    console.log("inside open modal");
    // this.selectedItem = item;
    this.modalRef = this.modalService.show(template, { class: "modal-sm" });
  }
  confirm() {
    console.log("inside confirm modal");

    this.Deletefnc();
    this.modalRef.hide();
  }
  decline() {
    console.log("inside decline modal");

    // this.message = 'Declined!';
    this.modalRef.hide();
  }

  engineerlist() {
    this.inspection.getUserList_inspection().subscribe(
      (result: any) => {
        this.engineer = result.data;
        //console.log(this.engineer, "engineer test");
      },
      (error: any) => {
        this.loader = false;
        //this.nodata = true;
        // this.commonService.toast(error.error.message, 'Error');
      }
    );
  }
  getInspectionListByStatus(obj) {
    this.query.search = this.searchText;
    this.inspection.getinspectionlistbystatusV2(obj, this.query).subscribe(
      (result: any) => {
        const items = result.data.data;
        this.items = items;
        this.loader = false;
        this.nodata = false;
        this.totalRecords = result.data.totalCount;
        // this.excel = [];
        // //this.excel.push('Image', 'Inspection Mail Status', 'Confirmation Mail Status', '_id', 'Issue Type', 'Template Name', 'Descriptive Text', 'Name', 'Email', 'Address', 'City', 'State', 'Postcode', 'Phonenumber', 'Status', 'Reason', 'Date of enquiry', '_v','Inspection date','Inspection time', 'Confirmation date', 'Confirmation time', )
        // this.inspection.getInspectionListbyStatusForCsv(obj).subscribe(
        //   (result1: any) => {

        //     //this.excel.push('Image', 'Inspection Mail Status', 'Confirmation Mail Status', '_id', 'Issue Type', 'Template Name', 'Descriptive Text', 'Name', 'Email', 'Address', 'City', 'State', 'Postcode', 'Phonenumber', 'Status', 'Reason', 'Date of enquiry', '_v','Inspection date','Inspection time', 'Confirmation date', 'Confirmation time', )
        // let curVal = result1.data.data;
        // if (curVal.length > 0) {
        //   curVal.forEach((row) => {
        //     //delete objNew['_id'];
        //     console.log(row);
        //     this.excel.push(row);
        //   });
        // }})
        this.arr_temp_all = this.items.map((result) => result._id);
        //  console.log(this.arr_temp_all);
        if (obj == "Accepted") {
          this.listtype_both = false;
          this.listtype_Accepted = true;
          this.listtype_Rejected = false;
        } else if (obj == "Rejected") {
          this.listtype_both = false;
          this.listtype_Accepted = false;
          this.listtype_Rejected = true;
        }
      },
      (error: any) => {
        this.loader = false;
        this.nodata = true;
        // this.commonService.toast(error.error.message, 'Error');
      }
    );
  }

  pageChanged(event: any): void {
    this.p = event.page;
    this.query.page = this.p;
    this.getinspectionlist();
  }

  getinspectionlist() {
    this.query.search = this.searchText;
    this.inspection
      .getinspectionlistbystatusV2("Accepted", this.query)
      .subscribe(
        (result: any) => {
          const items = result.data.data;
          this.items = items;
          this.totalRecords = result.data.totalCount;
          // this.excel = [];
          // //this.excel.push()
          // this.inspection.getInspectionListbyStatusForCsv("Accepted").subscribe(
          //   (result1: any) => {

          //     //this.excel.push('Image', 'Inspection Mail Status', 'Confirmation Mail Status', '_id', 'Issue Type', 'Template Name', 'Descriptive Text', 'Name', 'Email', 'Address', 'City', 'State', 'Postcode', 'Phonenumber', 'Status', 'Reason', 'Date of enquiry', '_v','Inspection date','Inspection time', 'Confirmation date', 'Confirmation time', )
          // let curVal = result1.data.data;
          // if (curVal.length > 0) {
          //   curVal.forEach((row) => {
          //     //delete objNew['_id'];
          //     console.log(row);
          //     this.excel.push(row);
          //   });
          // }})
          this.arr_temp_all = this.items.map((result) => result._id);
          // console.log(this.arr_temp_all);
          this.loader = false;
          this.nodata = false;
          this.listtype_both = true;
          this.listtype_Accepted = false;
          this.listtype_Rejected = false;
        },
        (error: any) => {
          this.loader = false;
          this.nodata = true;
          // this.commonService.toast(error.error.message, 'Error');
        }
      );
  }
  copydata(index) {
    var doc = "";
    var table = document.getElementById("myTable") as HTMLTableElement;
    //var row,header,cell1, cell2;
    for (var i = 0; i < 8; i++) {
      //var date = table.rows[index+1].cells[i].innerText
      //doc.push(table.rows[index + 1].cells[i].innerText);
      //console.log(table.rows[index+1].cells[i].innerText);
      doc = doc + table.rows[index + 1].cells[i].innerText + "\t";
    }
    console.log(doc);
    //doc.splice(9, 6);
    //doc.splice(0, 1);
    //doc.join('\r\n');
    //doc.join("\n")
    //console.log(doc)
    //var str = doc.toString();
    //str.replace(",", "<br />");
    //this.copyStringToClipboard(table.rows[index+1].innerText)
    this.copyStringToClipboard(doc);
  }
  copyStringToClipboard(str) {
    // Create new element
    var el = document.createElement("textarea");
    // Set value (string to be copied)
    el.value = str;
    // Set non-editable to avoid focus and move outside of view
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    //el.style = {position: 'absolute', left: '-9999px'};

    document.body.appendChild(el);
    // Select text inside element
    el.select();
    // Copy text to clipboard
    document.execCommand("copy");
    // Remove temporary element
    document.body.removeChild(el);
  }

  Deletefnc() {
    // this.obj = {
    //obj : this.arr_temp
    //}
    if (this.arr_temp.length == 0) {
      this.commonService.toast("Please select an enquiry to delete", "Error");
    } else {
      this.inspection.deleteinspectionlist(this.arr_temp).subscribe(
        (result: any) => {
          this.loader = true;
          this.pagecall();
          this.loader = false;
          this.commonService.toast("Deletion successful", "Success");
        },
        (error: any) => {
          this.loader = false;
          //this.nodata = true;
          // this.commonService.toast(error.error.message, 'Error');
        }
      );
    }
  }

  // exportAsXLSX(): void {
  //   this.excelService.exportAsExcelFile(this.excel, "User");
  // }
  exportAsXLSX(): void {
    const url = this.APIEndpoint + '/' + 'users/genereate-csv/Accepted'; // URL to your CSV file endpoint

    // Open the link in a new tab
    const newTab = window.open(url, '_blank');

    if (newTab) {
      // Wait for the new tab to load and trigger the download
      newTab.onload = () => {
        // Set the download behavior for the new tab by modifying its headers on the server side
        // Ensure that your server is sending the correct headers like Content-Disposition for file download
        newTab.location.href = url;  // This triggers the download if the server is set up correctly
      };
    } else {
      console.error('Could not open new tab');
    }
  }
  pagecall() {
    if (this.listtype_both == true) {
      this.getinspectionlist();
    } else if (this.listtype_Accepted == true) {
      this.getInspectionListByStatus("Accepted");
    } else if (this.listtype_Rejected == true) {
      this.getInspectionListByStatus("Rejected");
    }
  }
  userModal(userid) {
    //console.log(userid);
    const initialState = {
      userid: userid,
    };
    this.modalService.show(UserModalComponentComponent, {
      initialState,
      class: "modal-lg",
    });
    this.modalService.onHide.subscribe(() => {
      this.pagecall();
    });
  }

  updateTime(item: any, timeKey: string, event: any): void {
    console.log(item, timeKey, event);
    item[timeKey] = event;
  }

  sendeinspectionmail(
    emailid,
    date,
    itime,
    _id,
    refnum,
    itime1,
    engineer,
    name
  ) {
    var d = new Date(date);
    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";

    var n = weekday[d.getDay()];
    //var n = d.getDay();

    let obj1 = {
      email: emailid,
      date: date,
      itime: itime,
      _id: _id,
      refnum: refnum,
      itime1: itime1,
      day: n,
      engineer: engineer,
      name: name,
    };

    if (
      date == "" ||
      date == undefined ||
      itime == "" ||
      itime == undefined ||
      itime1 == "" ||
      itime1 == undefined
    ) {
      this.commonService.toast("Please select the date and time", "Error");
    } else if (engineer == "" || engineer == undefined) {
      this.commonService.toast(
        "Please select engineer Before sending email",
        "Error"
      );
    } else {
      this.inspection.sendeinspectionmail(obj1).subscribe(
        (result: any) => {
          this.commonService.toast(
            `Inspection email sent successfully.`,
            "Success"
          );
          this.pagecall();
        },
        (error) => {
          this.commonService.toast(error.error.message, "Error");
        }
      );
    }
  }
  sendconfirmationemail(
    emailid,
    date,
    ctime,
    _id,
    refnum,
    ctime1,
    engineer,
    name
  ) {
    var d = new Date(date);
    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";

    var n = weekday[d.getDay()];

    let obj2 = {
      email: emailid,
      date: date,
      ctime: ctime,
      _id: _id,
      refnum: refnum,
      ctime1: ctime1,
      day: n,
      engineer: engineer,
      name: name,
    };
    if (
      date == "" ||
      date == undefined ||
      ctime == "" ||
      ctime == undefined ||
      ctime1 == "" ||
      ctime1 == undefined
    ) {
      this.commonService.toast("Please select the date and time", "Error");
    } else if (engineer == "" || engineer == undefined) {
      this.commonService.toast(
        "Please select engineer Before sending email",
        "Error"
      );
    } else {
      this.inspection.sendconfirmationemail(obj2).subscribe(
        (result: any) => {
          this.commonService.toast(
            `Confirmation email  sent successfully.`,
            "Success"
          );
          this.pagecall();
        },
        (error) => {
          this.commonService.toast(error.error.message, "Error");
        }
      );
    }
  }
  navSelected(_id, navName) {
    console.log(navName + " Clicked!");
    const eng = this.engineer.filter((e) => e._id == navName);
    console.log(eng);
  }
  changeEngineer(_id, event, index) {
    const engineer = event.target.value;
    console.log(engineer);
    this.inspection.updateEngineer({ _id, engineer: engineer }).subscribe(
      (result: any) => {
        this.commonService.toast(`Engineer updated successfully.`, "Success");
        this.pagecall();
      },
      (error) => {
        this.commonService.toast(error.error.message, "Error");
      }
    );
  }
  // changeStatus(_id, event) {
  //   const status = event.target.value;
  //   this.inspection.updateStatus({ _id, Status: status }).subscribe(
  //     (result: any) => {
  //       this.commonService.toast(`Status updated successfully.`, "Success");
  //       this.pagecall();
  //     },
  //     (error) => {
  //       this.commonService.toast(error.error.message, "Error");
  //     }
  //   );
  // }
  changeStatus(_id, event) {
    const status = event.target.value;
    console.log("changeStatus status", _id, status);

    // First, check if the status is "Deleted" and delete the enquiry if it is
    if (status === "Deleted") {
      console.log("Enquiry will be deleted now.");

      // Call the delete function if the status is 'Deleted'
      this.inspection.deleteinspectionlist([_id]).subscribe(
        (result: any) => {
          console.log("Enquiry deleted result", result);
          this.loader = true;
          this.pagecall(); // Refresh the list after deletion
          this.loader = false;
          // this.commonService.toast("Enquiry deleted successfully", "Success");
        },
        (error: any) => {
          this.loader = false;
          this.commonService.toast(error.error.message, "Error");
        }
      );
    }

    // If the status is valid, update it
    this.inspection.updateStatus({ _id, Status: status }).subscribe(
      (result: any) => {
        console.log("Status update result", result);
        this.commonService.toast("Status updated successfully", "Success");
        this.pagecall(); // Refresh the list with the updated status

        // Now handle the reason change after updating status
        // this.changereason(_id, event); // Call changereason to update the reason if needed
      },
      (error) => {
        this.commonService.toast(error.error.message, "Error");
      }
    );
  }
  // changereason(_id, event) {
  //   const reason = event.target.value;

  //   if (this.status == "") {
  //     this.commonService.toast(
  //       "Please select the status before selecting the reason",
  //       "Error"
  //     );
  //     this.pagecall();
  //   } else if (this.status == "Accepted") {
  //     this.commonService.toast("The enquiry is in accepted state", "Error");
  //     this.pagecall();
  //   } else {
  //     this.inspection.updatereason({ _id, Reason: reason }).subscribe(
  //       (result: any) => {
  //         // this.commonService.toast(`Reason updated successfully.`, "Success");
  //         this.pagecall();
  //       },
  //       (error) => {
  //         this.commonService.toast(error.error.message, "Error");
  //       }
  //     );
  //   }
  // }

  // changereason(_id, event) {
  //   const reason = event.target.value;

  //   // Make sure a status is selected and it's not "Accepted"
  //   if (this.status == "") {
  //     this.commonService.toast(
  //       "Please select the status before selecting the reason",
  //       "Error"
  //     );
  //     this.pagecall();
  //   } else if (this.status == "Accepted") {
  //     this.commonService.toast("The enquiry is in accepted state", "Error");
  //     this.pagecall();
  //   } else {
  //     // Proceed to update the reason if status is valid
  //     this.inspection.updatereason({ _id, Reason: reason }).subscribe(
  //       (result: any) => {
  //         this.commonService.toast(`Reason updated successfully.`, "Success");
  //         this.pagecall();
  //       },
  //       (error) => {
  //         this.commonService.toast(error.error.message, "Error");
  //       }
  //     );
  //   }
  // }

  deleteselection(_id, check) {
    if (check.target.checked == true) {
      this.arr_temp.push(_id);
      //console.log(this.arr_temp);
    } else if (check.target.checked == false) {
      for (let j = 0; j < this.arr_temp.length; j++) {
        if (this.arr_temp[j] === _id) {
          this.arr_temp.splice(j, 1);
        }
      }
      // console.log(this.arr_temp);
    }
  }
  deleteall(event) {
    const checked = event.target.checked;
    this.items.forEach((item) => (item.selected = checked));
    if (checked == true) {
      this.arr_temp = this.arr_temp_all;
    } else if (checked == false) this.arr_temp = [];
    // console.log(this.arr_temp);
  }
  listchange(event) {
    const listval = event.target.value;
    if (listval == "Both") {
      this.getinspectionlist();
    } else if (listval == "Accepted") {
      this.getInspectionListByStatus("Accepted");
    } else if (listval == "Rejected") {
      this.getInspectionListByStatus("Rejected");
    }
  }
  selectinspectiondate(_id, event) {
    const bdate = event.target.value;
    this.inspection.selectinspectiondate({ _id, idate: bdate }).subscribe(
      (result: any) => {
        this.commonService.toast(
          `Inspection date updated successfully.`,
          "Success"
        );
        this.pagecall();
      },
      (error) => {
        this.commonService.toast(error.error.message, "Error");
      }
    );
  }
  selectinspectiondate1(_id, event) {
    const bdate = event.target.value;
    this.inspection.selectinspectiondate1({ _id, cdate: bdate }).subscribe(
      (result: any) => {
        this.commonService.toast(
          `Confirmed date updated successfully.`,
          "Success"
        );
        this.pagecall();
      },
      (error) => {
        this.commonService.toast(error.error.message, "Error");
      }
    );
  }

  timeset(_id, index) {
    //const bdate = .target.value;
    //var bdate = document.getElementById("time1").value;
    //var bdate = (<HTMLInputElement>document.getElementById("time1")).value;
    var table = document.getElementById("myTable") as HTMLTableElement;
    //console.log("chirag test", table.rows[index + 1])
    //var bdate1 = table.rows[index + 1];
    //console.log(table.rows[index + 1].cells[9].getElementsByTagName("input")[1].value);
    var bdate =
      table.rows[index + 1].cells[8].getElementsByTagName("input")[1].value;
    //console.log(bdate);
    this.inspection.selectinspectiontime1({ _id, itime: bdate }).subscribe(
      (result: any) => {
        this.commonService.toast(
          `Inspection time updated successfully.`,
          "Success"
        );
        this.pagecall();
      },
      (error) => {
        this.commonService.toast(error.error.message, "Error");
      }
    );
  }

  timeset11(_id, index) {
    //const bdate = .target.value;
    //var bdate = document.getElementById("time1").value;
    //var bdate = (<HTMLInputElement>document.getElementById("time111")).value;
    var table = document.getElementById("myTable") as HTMLTableElement;
    var bdate =
      table.rows[index + 1].cells[8].getElementsByTagName("input")[2].value;
    this.inspection.selectinspectiontime13({ _id, itime1: bdate }).subscribe(
      (result: any) => {
        this.commonService.toast(
          `Inspection time updated successfully.`,
          "Success"
        );
        this.pagecall();
      },
      (error) => {
        this.commonService.toast(error.error.message, "Error");
      }
    );
  }
  timeset14(_id, index) {
    //const bdate = .target.value;
    //var bdate = document.getElementById("time1").value;
    //var bdate = (<HTMLInputElement>document.getElementById("time22")).value;
    var table = document.getElementById("myTable") as HTMLTableElement;
    var bdate =
      table.rows[index + 1].cells[9].getElementsByTagName("input")[2].value;
    this.inspection.selectinspectiontime25({ _id, ctime1: bdate }).subscribe(
      (result: any) => {
        this.commonService.toast(
          `Inspection time updated successfully.`,
          "Success"
        );
        this.pagecall();
      },
      (error) => {
        this.commonService.toast(error.error.message, "Error");
      }
    );
  }
  timeset1(_id, index) {
    //const bdate = .target.value;
    //var bdate = document.getElementById("time1").value;
    //var bdate = (<HTMLInputElement>document.getElementById("time2")).value;
    var table = document.getElementById("myTable") as HTMLTableElement;
    var bdate =
      table.rows[index + 1].cells[9].getElementsByTagName("input")[1].value;
    this.inspection.selectinspectiontime2({ _id, ctime: bdate }).subscribe(
      (result: any) => {
        this.commonService.toast(
          `Inspection time updated successfully.`,
          "Success"
        );
        this.pagecall();
      },
      (error) => {
        this.commonService.toast(error.error.message, "Error");
      }
    );
  }
}
